import React from 'react'
import { Button } from 'reactstrap'
import { SuitcaseSimple } from "phosphor-react"
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { processError } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class PartnerDesc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            project: {
                title: '',
                image: '',
                desc: '',
                url: '',
            },
            projectLoaded: false,
            imageLoaded: false,
            dataLoaded: false,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
        this.readMore = this.readMore.bind(this)
    }

    getProjectInfo(id, token, lang) {
        return new Promise((resolve, reject) => {
            api.getProjectInfo(id, token, lang)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    readMore() {
        window.open(this.state.project.url, "_blank")
    }

    componentWillMount() {
        const accessToken = cookies.get('accessToken')
        let arrPromise = [
            this.getProjectInfo(this.props.match.params.projectId, accessToken, this.props.i18n.language).then((project) => this.setState({ project, projectLoaded: true })),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        return (
            <div className="project card">
                <div className="img-wrapper">
                    {!this.state.imageLoaded && this.state.project.image && <div className="card-img"><Skeleton height={400} image={true} /></div>}
                    {this.state.project.image && <img onLoad={() => this.setState({ imageLoaded: true })} src={`${this.state.imageUrl}/${this.state.project.image}`} alt="" className={`card-img${this.state.imageLoaded ? '' : ' d-none'}`} />}
                    {this.state.projectLoaded && <div className="link md-font-size">{t('partners-projects')} / {this.state.project.title}</div>}
                </div>
                {
                    this.state.projectLoaded ?
                        <div className="card-body">
                            <div className="card-title xl-font-size">{this.state.project.title}</div>
                            <div className="card-desc" dangerouslySetInnerHTML={{ __html: this.state.project.content }}></div>
                        </div>
                        :
                        <div className="card-body">
                            <div className="card-title xl-font-size"><Skeleton width={'20%'} /></div>
                            <div className="card-desc"><Skeleton count={5} /></div>
                        </div>
                }
                {
                    this.state.dataLoaded ?
                        <Button
                            type="button"
                            className="btn profile-avatar-btn primary p-10-20px"
                            onClick={this.readMore}
                            disabled={!this.state.project.url}
                        >
                            <div className="d-flex align-items-center justify-content-center">
                                <SuitcaseSimple size={20} color="#ffffff" />
                                <span className="pl-5px sm-font-size">{t('partners-partners-website')}</span>
                            </div>
                        </Button>
                        :
                        <Skeleton button={true} className="mt-5 btn profile-avatar-btn primary p-10-20px" />
                }
            </div>
        )
    }
}

PartnerDesc.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(PartnerDesc)



// WEBPACK FOOTER //
// ./src/views/Partners/PartnerDesc.jsx